import { Helmet } from 'react-helmet';

const SchemaMarkup = () => {
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Restaurant',
        'name': 'Curious Mug',
        'description': 'Curious Mug is a modern restaurant & bar located in Rise Palm Street, Sector 1, Greater Noida. Known for its great ambience, signature cocktails, premium food experience, and vibrant hangout vibe, it’s one of the most recommended dining and nightlife spots in the area.',
        'url': 'https://curiousmug.com', 
        'telephone': '+91-8448133897', 
        'address': {
          '@type': 'PostalAddress',
          'streetAddress': 'Rise Palm Street, Sector 1',
          'addressLocality': 'Greater Noida',
          'addressRegion': 'UP',
          'postalCode': '201306', 
          'addressCountry': 'IN'
        },
        'geo': {
          '@type': 'GeoCoordinates',
          'latitude': '28.5758', 
          'longitude': '77.4280' 
        },
        'servesCuisine': 'Modern Indian, Cocktails',
        'priceRange': '₹₹',
        'openingHoursSpecification': [
          {
            '@type': 'OpeningHoursSpecification',
            'dayOfWeek': [
              'Monday',
              'Tuesday',
              'Wednesday',
              'Thursday',
              'Friday',
              'Saturday',
              'Sunday'
            ],
            'opens': '12:00',
            'closes': '23:59'
          }
        ],
        'menu': 'https://curiousmug.com/menu', 
        'acceptsReservations': 'True',
        'image': 'https://res.cloudinary.com/drc2niu3q/image/upload/f_auto,q_auto,w_1200/v1764308520/IMG_8181_j1dcs9.jpg',
        'review': [
            {
                '@type': 'Review',
                'author': {
                    '@type': 'Person',
                    'name': 'Priya Sharma'
                },
                'reviewRating': {
                    '@type': 'Rating',
                    'ratingValue': '5'
                },
                'reviewBody': 'The cocktails here are absolutely divine! Each drink is a work of art, and the ambiance is perfect for a night out.'
            },
            {
                '@type': 'Review',
                'author': {
                    '@type': 'Person',
                    'name': 'Rahul Mehta'
                },
                'reviewRating': {
                    '@type': 'Rating',
                    'ratingValue': '5'
                },
                'reviewBody': 'Best bar in town! The staff is knowledgeable, the food is exceptional, and I always discover new favorite drinks here.'
            }
        ]
      },
      {
        '@type': 'BarOrPub',
        'name': 'Curious Mug',
        'description': 'A vibrant bar serving signature cocktails and premium drinks in Greater Noida. A popular place for hangouts and weekend nightlife.',
        'url': 'https://curiousmug.com', 
        'address': {
            '@type': 'PostalAddress',
            'streetAddress': 'Rise Palm Street, Sector 1',
            'addressLocality': 'Greater Noida',
            'addressRegion': 'UP',
            'postalCode': '201306',
            'addressCountry': 'IN'
        },
        'telephone': '+91-8448133897', 
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default SchemaMarkup;
